import { createFileRoute } from '@tanstack/react-router';

import { LostReasonsPage } from '@/features/attribution/pages/lost-reasons';

export const Route = createFileRoute('/_app/settings/lost-reasons')({
  component: LostReasonsPage,
});
